import {
    GET_ALL_CATEGORIES_WEB_SYS,
    GET_ALL_CATEGORIES_WEB,
    UPDATE_CATEGORY_WEB,
    DELETE_CATEGORY_WEB,
    SET_CATEGORY,
    LOADING_CATE,
    POST_CATEGORY_WEB
 } from '../types';

const initialState = {
    categories_web_sys: [],
    categories_web: [],
    categories: [],
    category: {},
    loading: false
}

var findIndex = (initialState, id) => {
    var result = -1;
    initialState.categories_web_sys.forEach((category, index) => {
        if(category.categoryId === id) {
            result = index;
        }
    });
    
    return result;
}

export default function(state = initialState, action) {
    var id = '';
    var updateChange = '';
    var index = -1;
    switch(action.type){
        case LOADING_CATE:
            return {
                ...state,
                loading: true
            };
        case GET_ALL_CATEGORIES_WEB_SYS:
            return {
                ...state,
                categories_web_sys: action.payload,
            };
        case GET_ALL_CATEGORIES_WEB:
            return {
                ...state,
                categories_web: action.payload,
            };
        case POST_CATEGORY_WEB:
                return {
                    ...state,
                    categories_web_sys: [
                        ...state.categories_web_sys,
                        action.payload,
                    ]
                }
        case SET_CATEGORY:
            return {
                ...state,
                category: action.payload,
                loading: false
            }
        case UPDATE_CATEGORY_WEB: 
            id = action.categoryId;
            updateChange = action.payload;
            index = findIndex(state, id);
            state.categories_web_sys[index] = {
                ...state.categories_web_sys[index],
                ...updateChange
            };
            state.category = {
                ...state.category,
                ...updateChange
            }
            return state;
        case DELETE_CATEGORY_WEB: 
            id = action.categoryId;
            index = findIndex(state, id);
            state.categories_web_sys.splice(index, 1);
            return state;
        default:
            return state;
    }
}